export enum LocalStorageKey {
  AccessToken = "accessToken",
  SchedulesNotStarted = "schedulesNotStarted",
  DeliveryGroupsExpectedToBeDelayed = "deliveryGroupsExpectedToBeDelayed",
  DeliveryGroupsCompletedWithoutImage = "deliveryGroupsCompletedWithoutImage",
  DeliveryGroupsCompletedWithDelay = "deliveryGroupsCompletedWithDelay",
  AlertDate = "alertDate",
}
